<div
  data-cid="ui-modal"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="hasTitle() ? 'modal-title' : null"
  [attr.aria-describedby]="hasDescription() ? 'modal-description' : null"
  class="flex flex-col overflow-hidden bg-neutral-hight-pure px-4 py-4 sm:relative sm:w-[calc(100vw-3rem)] sm:px-8 sm:py-6"
  [ngStyle]="{
    backgroundColor: backgroundColor()
  }"
  [ngClass]="{
    'max-sm:flex max-sm:h-screen max-sm:w-screen max-sm:rounded-none':
      isFullscreenOnMobile(),
    'relative max-h-[90svh] w-[calc(100vw-2rem)]': !isFullscreenOnMobile(),
    'sm:max-h-[90svh]': isFullscreenOnMobile(),
    'sm:max-w-md': size() === 'xs',
    'sm:max-w-lg': size() === 'sm',
    'sm:max-w-xl': size() === 'md',
    'sm:max-w-3xl': size() === 'lg',
    'sm:max-w-5xl': size() === 'xl',
    'sm:max-w-7xl': size() === '2xl',
    'rounded-none': rounded() === 'none',
    rounded: rounded() === 'sm',
    'rounded-lg': rounded() === 'md',
    'rounded-2xl': rounded() === 'lg',
    'rounded-3xl': rounded() === 'xl'
  }"
>
  @if (shouldShowTopBar()) {
    <div
      class="flex shrink-0 items-start justify-between gap-4"
      [class.mb-4]="hasTitle()"
      [class.border-b]="hasTitle()"
      [class.border-neutral-hight-medium]="hasTitle()"
      [class.pb-4]="hasTitle()"
    >
      <div class="min-w-0 flex-1">
        @if (hasTitle()) {
          <h2
            id="modal-title"
            class="text-lg font-semibold text-neutral-low-dark sm:text-xl"
          >
            {{ config().title }}
          </h2>
        }

        @if (hasDescription()) {
          <p
            id="modal-description"
            class="mt-1 text-sm text-neutral-low-medium"
          >
            {{ config().description }}
          </p>
        }
      </div>

      @if (shouldShowCloseButton()) {
        <button
          type="button"
          aria-label="Fechar modal"
          class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full p-0 leading-none text-brand-primary-pure outline-none ring-offset-brand-primary-lightest transition-colors hover:text-brand-primary-dark focus:outline-none focus:ring-2 focus:ring-brand-primary-lighter focus:ring-offset-2"
          [ngClass]="closeButtonVisibilityClass()"
          (click)="onClose()"
        >
          <ng-icon name="featherXCircle" size="24" />
        </button>
      }
    </div>
  }

  @if (component()) {
    <div class="flex min-h-0 flex-1 flex-col overflow-y-auto overflow-x-hidden">
      <ng-container
        *ngComponentOutlet="component(); injector: dynamicComponentInjector"
      />
    </div>
  }
</div>
